import { shallowRef } from 'vue'
import { defineStore } from '../store'
import axios from 'axios'
import tableColumns from '@public/config/columns.json'

interface Table {
    tableKey: string;
    columns: TableColumn[];
}

interface TableColumn {
    field: string;
    label: string;
    className?: string;
    align?: string;
    width?: number;
    sortable?: boolean;
    show?: boolean;
    fixed?: 'left' | 'right';
    decimal?: number; // 保留小数点位数
}

/**
 * 表头列存储对象
 */
export const useTableColumnsStore = defineStore(() => {
    const tables = shallowRef<Table[]>([])

    const getColumnsAsync = axios('./config/columns.json').then((res) => {
        tables.value = mergeTables(tableColumns, res.data)
    })

    const getTableColumns = (tableKey: string, operateColumn = false) => {
        return new Promise<TableColumn[]>((resolve) => {
            getColumnsAsync.finally(() => {
                const table = tables.value.find((e) => e.tableKey === tableKey)
                if (table) {
                    const baseColumns: TableColumn[] = [...table.columns]
                    if (operateColumn) {
                        baseColumns.push({
                            field: 'operate',
                            label: 'common.operate',
                            fixed: 'right'
                        })
                    }
                    resolve(baseColumns)
                }
                resolve([])
            })
        })
    }

    const updateColumns = (data: TableColumn[]) => {
        console.log(data)
    }

    return {
        tables,
        getTableColumns,
        updateColumns
    }
})

const mergeTables = (target: Table[], source: Table[]) => {
    const targetMap = new Map<string, Table>(target.map(t => [t.tableKey, t]))
    for (const table of source) {
        const existingTable = targetMap.get(table.tableKey)
        if (existingTable) {
            // 如果tableKey已存在，则合并属性
            Object.assign(existingTable, table, {
                columns: mergeColumns(existingTable.columns, table.columns)
            })
        } else {
            // 如果tableKey不存在，则新增记录
            targetMap.set(table.tableKey, table)
        }
    }
    return Array.from(targetMap.values())
}

const mergeColumns = (target: TableColumn[], source: TableColumn[]) => {
    const targetMap = new Map<string, TableColumn>(target.map(c => [c.field, c]))
    for (const column of source) {
        const existingColumn = targetMap.get(column.field)
        if (existingColumn) {
            // 如果field已存在，则合并属性
            Object.assign(existingColumn, column)
        } else {
            // 如果field不存在，则新增记录
            targetMap.set(column.field, column)
        }
    }
    return Array.from(targetMap.values())
}